// noinspection JSUnusedGlobalSymbols
export default function () {

    const luhn = require('luhn-alg');
    const $invalidMessage = $('#invalid-message');
    const $validMessage = $('#valid-message');
    const $submitButton = $('#next-button');
    const itemID = parseInt($('#item-id').data('item-id'));
    const $itemValueInput = $('#item-id-' + itemID);

    // If one of the five fields change
    for (let i = 1; i <= 5; i++) {
        const elementID = '#item-id-' + itemID + '-' + i;
        $(elementID).on('change keyup', function () {
            // Only process if the last field is selected
            if (isLastFieldSelected(itemID)) {
                let isValid = false;
                if (isTextCodeEnteredCompletely(itemID)) {
                    const code = getProbandGroupdCode(itemID);
                    if (code) {
                        // Check code with the luhn algorithm
                        isValid = luhn(code);
                    }
                }
                if (isValid) {
                    // Set the displayed code as the value of the hidden input field which will be submitted
                    const displayedCode = getDisplayedCode(itemID);
                    $itemValueInput.val(displayedCode);
                    hideErrorMessage($invalidMessage);
                    showSuccessMessage($validMessage);
                } else {
                    hideSuccessMessage($validMessage);
                    showErrorMessage($invalidMessage);
                }
            }
        });
    }

    $submitButton.on('click', function (event) {
        let isValid: boolean;
        const code = getProbandGroupdCode(itemID);
        if (code) {
            // Check code with the luhn algorithm
            isValid = luhn(code);
        } else {
            isValid = false;
        }
        if (!isValid) {
            event.preventDefault();
            hideSuccessMessage($validMessage);
            showErrorMessage($invalidMessage);
        }
    });
}

/**
 * It returns the proband group code that the user entered or false if there is no valid input.
 * The code consists of the input values of the five seperate fields.
 */
function getProbandGroupdCode(itemID: number): string|false {
    let code = '';
    for (let i = 1; i <= 5; i++) {
        const elementID = '#item-id-' + itemID + '-' + i;
        const value = (<string>$(elementID).val()).trim();
        const isValid = !(value.length < 1 || value.match(/\D/g) !== null || parseInt(value) < 0);
        if (!isValid) {
            return false;
        }
        code = code.concat(value);
    }
    return code;
}

/**
 * It returns the displayed code that the user entered. The code consists of the visible
 * values of the five seperate fields and the delimiter symbols.
 */
function getDisplayedCode(itemID: number): string {
    const delimiters = ['-', '.', '.', '-'];
    let displayedCode = '';
    for (let i = 1; i <= 5; i++) {
        const elementID = '#item-id-' + itemID + '-' + i;
        let snippet = $(elementID + ' option:selected').text();
        if (!snippet) {
            snippet = (<string>$(elementID).val()).trim();
        }
        if (i <= 4) {
            snippet = snippet.concat(delimiters[i - 1]);
        }
        displayedCode = displayedCode.concat(snippet);
    }
    return displayedCode;
}

function isLastFieldSelected(itemID: number): boolean {
    const elementID = '#item-id-' + itemID + '-5';
    const value = <string>$(elementID).val();
    // Has a negative value if not selected
    return !(parseInt(value) < 0);
}

function isTextCodeEnteredCompletely(itemID: number): boolean {
    const elementID = '#item-id-' + itemID + '-4';
    const textCode = <string>$(elementID).val();
    return textCode && textCode.length === 5;
}

function showErrorMessage($errorMessage: JQuery<HTMLElement>) {
    $errorMessage.removeClass('d-none');
    $errorMessage.addClass('d-block');
}

function hideErrorMessage($errorMessage: JQuery<HTMLElement>) {
    $errorMessage.removeClass('d-block');
    $errorMessage.addClass('d-none');
}

function showSuccessMessage($successMessage: JQuery<HTMLElement>) {
    $successMessage.removeClass('d-none');
    $successMessage.addClass('d-block');
}

function hideSuccessMessage($successMessage: JQuery<HTMLElement>) {
    $successMessage.removeClass('d-block');
    $successMessage.addClass('d-none');
}
